import ConfirmationModalView from '@/components/modules/modals/ConfirmationModalView';
import { _t } from '@/locale';
import { GiftCardType } from '../../types/types';

const baseTranslation = 'features.giftcard-self-serve.components.modals.ConfirmReturn';

const ConfirmReturn = ({
  isOpen,
  giftcardType,
  handleRefund,
  onCancel,
  loading,
}: {
  isOpen: boolean;
  giftcardType: GiftCardType;
  handleRefund: () => void;
  onCancel: () => void;
  loading?: boolean;
}) => {
  return (
    <ConfirmationModalView
      isOpen={isOpen}
      title={_t(`features.giftcard-self-serve.GiftcardSelfServe.returnGiftcardCta`)}
      subTitle={_t(`${baseTranslation}.subTitle`)}
      confirmText={_t(`features.giftcard-self-serve.GiftcardSelfServe.returnGiftcardCta`)}
      cancelText={_t('abort')}
      isLoading={loading}
      body={
        <div className="text-m">
          <span className="text-fg_secondary">{_t(`${baseTranslation}.body1`)}</span>{' '}
          <span className="font-bold">
            {giftcardType === 'wellness'
              ? _t(`${baseTranslation}.body2.wellness`)
              : _t(`${baseTranslation}.body2.giftcard`)}
          </span>
        </div>
      }
      onConfirm={handleRefund}
      onCancel={onCancel}
    />
  );
};

export default ConfirmReturn;
